import $ from 'jquery';
import zip from 'lib/util/zip';
import tdaConfig from 'lib/util/tda.config';
import cookies from 'utils/cookies';
import ctaTypes from './cta.types';
import DealerSearchModal from './dealer.search.modal';

var __type = ctaTypes['dealerSearchInventory']; // eslint-disable-line dot-notation
var __isWWW = tdaConfig.tda.code === 'WWW';
var __isMirai = window.location.search.indexOf('mirai') >= 0;
var __selectedSeries = '';

function __jsonponload(url, onloadCallback) {
  var script = document.createElement('script');
  script.src = url;
  script.async = true;
  var done = false;
  script.onload = function () {
    if (!done && (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete')) {
      done = true;
      script.onload = null;
      if (script && script.parentNode) {
        script.parentNode.removeChild(script);
      }
      if (onloadCallback) {
        onloadCallback();
      }
    }
  };
  var head = document.getElementsByTagName('head')[0];
  head.appendChild(script);
}

var dealerSearchInventoryCta = {
  dealerSelect: function (e, selectedDealer) {
    e.preventDefault();
    __jsonponload('https://datcdn.com/toyota_dat/getClickthroughURL.php?tda=' + selectedDealer.tdaCode + '&dealerCode=' + selectedDealer.dealerCode + '&series=' + __selectedSeries,
      function () {
        if (typeof (window.clickthroughURL) === 'string' && window.clickthroughURL) {
          window.clickthroughURL = window.clickthroughURL.replace(/utm_content=[^&]+/, '').replace(/([\?&])&/, '$1').replace(/[\?&]$/, '');
          window.clickthroughURL += window.clickthroughURL.indexOf('?') > -1 ? '&' : '?';
          window.clickthroughURL += 'utm_content=odp';
          window.open(window.clickthroughURL, '_blank');
        }
      });
  }
};

Object.setPrototypeOf(dealerSearchInventoryCta, DealerSearchModal);

export default function ($scope, dealerUrl, series) {
  __selectedSeries = series;
  var $ctaScope = $scope || $('body');
  var $ctas = $("a[data-destination='" + __type + "']", $ctaScope);
  if (!$ctas.length) return;

  if (dealerUrl) {
    $ctas.attr({
      target: '_blank',
      href: dealerUrl
    });
    return;
  }

  if (!dealerUrl) {
    $ctas.attr('data-km', '');
  }

  if (series && series === 'mirai') {
    dealerSearchInventoryCta.setMode('mirai');
  }

  $ctas.on('click', function (e) {
    e.preventDefault();
    // when this CTA is on a mirai page, we disable PMA mode
    if (__isMirai) dealerSearchInventoryCta.setMode('mirai');
    if (__isWWW || cookies.getItem('isConfirmedZip') !== 'true') {
      dealerSearchInventoryCta.enterZip();
    } else {
      dealerSearchInventoryCta.beginSearch(zip.getCookiedDefaultFallback(), __type);
    }
  });
};
